import { render, staticRenderFns } from "./MonetizationTag.vue?vue&type=template&id=6f49bd30&scoped=true"
import script from "./MonetizationTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./MonetizationTag.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MonetizationTag.vue?vue&type=style&index=0&id=6f49bd30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f49bd30",
  null
  
)

export default component.exports